export default "mutation addUserOwnRoles($userId: String!,$roleIds: [String]!) {\n  addUserOwnRoles(userId: $userId,roleIds: $roleIds) \n}";